import React, { PureComponent } from 'react'
import './FilterButton.scss'

class FilterButton extends PureComponent {
  render () {
    return (
      <div className='sc-filter'>
        <button className='sc-filter-btn'>
          <span aria-hidden='true' className='sc-filter-icon argos-icon icon-UIE-Filter' />
          <span className='sr-only'>Click here to apply </span>
          Filters
        </button>
      </div>
    )
  }
}

export default FilterButton



// WEBPACK FOOTER //
// ./src/components/Results/FilterButton/FilterButton.jsx